// extracted by mini-css-extract-plugin
export default {"cell":"styles_cell__0+i6v"};